import React from "react";
import {
    TabbedForm,
    FormTab,
    TextInput,
    SelectInput,
    ArrayInput,
    AutocompleteInput,
    NumberInput,
    ReferenceInput,
    Toolbar,
    SimpleFormIterator,
    FormDataConsumer
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

import streetTypes from "../helper/StreetTypes";
import PhoneArrayInput from "../component/PhoneArrayInput";
import areas from "../helper/Areas";
import required from "../helper/Required";

import CityAutoCompleteInputCustom from "../component/CityAutoCompleteInputCustom";
import StreetAutoCompleteInputCustom from "../component/StreetAutoCompleteInputCustom";
import SaveButtonAware from "../component/SaveButtonAware";
import RegionAutoCompleteInputCustom from "../component/RegionAutoCompleteInputCustom";
import DivisionMedicalProgramsInput from "../component/DivisionMedicalProgramsInput"
import WorkHoursInput from "../component/WorkHoursInput";
import WorkHoursInputWeekEnd from "../component/WorkHoursInputWeekEnd";

const useStyles = makeStyles((theme) => ({
    phones: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        marginBottom: 40,
        paddingBottom: 10,
        borderBottom: '1px solid grey',
        '& > div > ul > li > section': {
            display: "flex",
            flexWrap: "wrap",
            //width: "100%",
            '& > div': {
                width: "47%",
                //marginLeft: 10,
                '& > div': {
                    width: "100%"
                }
            }
        },
        '& > div > ul > li > span': {
            width: '30%'
        }
    }
}));

const defaultValueForWorkingHours = [
    {
        start: "",
        end: ""
    }
]

const Form = props => {
    const classes = useStyles();

    return (
        <TabbedForm {...props} validate={required.validateDivisionCreate}>
            <FormTab contentClassName="legal-entities-tab-content" label={<span>Загальна інформація <sup>*</sup></span>}>
                <ReferenceInput formClassName="tab-content-item" label="Обрати Юридичну особу" source="legalEntityId" reference="legal_entities" validate={required.validateRequired}>
                    <SelectInput optionText="edr.name" />
                </ReferenceInput>
                <TextInput formClassName="tab-content-item" label="Назва Аптеки" source="name" validate={required.validateRequiredDivisionName} />
                <SelectInput formClassName="tab-content-item" label="Тип закладу" source="type" validate={required.validateRequired} choices={[
                    { id: 'DRUGSTORE', name: 'Аптека' },
                    { id: 'DRUGSTORE_POINT', name: 'Аптечний пункт' },
                ]} />
                <TextInput formClassName="tab-content-item" label="E-mail" source="email" validate={required.validateRequired} />
                <TextInput formClassName="tab-content-item tab-content-item-last" label="Зовнішній ідентифікатор" source="externalId" />
            </FormTab>

            <FormTab contentClassName="legal-entities-tab-content" label={<span>Адреса <sup>*</sup></span>}>
                <SelectInput formClassName="tab-content-item" label="Область" source="area" choices={areas} validate={required.validateRequired} />
                <RegionAutoCompleteInputCustom formClassName="tab-content-item autocomplete help-text-custom" label="Район" source="region" />
                <CityAutoCompleteInputCustom formClassName="tab-content-item autocomplete help-text-custom" label="Населенний пункт" source="settlementId" validate={required.validateRequired} />
                <FormDataConsumer formClassName="tab-content-item">
                    {({ formData, ...rest }) => (
                        <SelectInput initialValue={formData.streetType ? formData.streetType : "STREET"} formClassName="tab-content-item" label="Тип вулиці" source="streetType" validate={required.validateRequired} choices={streetTypes} />
                    )}
                </FormDataConsumer>
                <StreetAutoCompleteInputCustom formClassName="tab-content-item autocomplete help-text-custom" label="Назва вулиці" optionValue="name" source="street" validate={required.validateRequired} />
                <TextInput formClassName="tab-content-item" label="Будинок" source="building" />
                <TextInput formClassName="tab-content-item" label="Кабінет" source="apartment" />
                <TextInput formClassName="tab-content-item" label="Поштовий індекс" source="zip" validate={required.validateRequiredZip} />

                <NumberInput formClassName="tab-content-item" label="Широта" source="latitude" max="90" min="-90" validate={required.validateRequired} />
                <NumberInput formClassName="tab-content-item" label="Довгота" source="longitude" max="90" min="-90" validate={required.validateRequired} />
            </FormTab>

            <FormTab label={<span>Телефони <sup>*</sup></span>}>
                <div className={classes.phones}>
                    <PhoneArrayInput label="Телефони" source="phones" validate={required.validateRequired} />
                </div>
            </FormTab>

            {/*{props.record?.id ?*/}
            {/*<FormTab label={<span>Мед. програми</span>}>*/}
            {/*    <div className={classes.phones}>*/}
            {/*        <DivisionMedicalProgramsInput label="Контракты" source="contracts" {...props} />*/}
            {/*    </div>*/}
            {/*</FormTab> : null}*/}

            <FormTab contentClassName="legal-entities-tab-content" label={<span>Години праці</span>}>
                <WorkHoursInput formClassName="tab-content-item-work-hour" label="Понеділок" source="workingHoursMon" defaultValue={defaultValueForWorkingHours} />
                <WorkHoursInput formClassName="tab-content-item-work-hour" label="Вівторок" source="workingHoursTue" defaultValue={defaultValueForWorkingHours} />
                <WorkHoursInput formClassName="tab-content-item-work-hour" label="Середа" source="workingHoursWed" defaultValue={defaultValueForWorkingHours} />
                <WorkHoursInput formClassName="tab-content-item-work-hour" label="Четвер" source="workingHoursThu" defaultValue={defaultValueForWorkingHours} />
                <WorkHoursInput formClassName="tab-content-item-work-hour" label="П'ятниця" source="workingHoursFri" defaultValue={defaultValueForWorkingHours} />
                <WorkHoursInputWeekEnd formClassName="tab-content-item-work-hour" label="Субота" source="workingHoursSat" defaultValue={defaultValueForWorkingHours} />
                <WorkHoursInputWeekEnd formClassName="tab-content-item-work-hour tab-content-item-work-hour-last" label="Неділя" source="workingHoursSun" defaultValue={defaultValueForWorkingHours} />
            </FormTab>
        </TabbedForm>
    );
}

export default Form;
